export default "__VITE_ASSET__74b521b8__"